import React from 'react';
import PropTypes from 'prop-types';
import { useSoyuzFlag } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';

import Translator from '../../cornucopia/core/translator';

import ContactData from './contact-data';

import SaturationMessage from './saturation-message';

const PersonalInfo = ({
  onFieldChange,
  onSubmitForm,
  formStatus,
  userType,
  userCountry
}) => {
  const contactSaturation = useSoyuzFlag('ContactSaturation');
  const handleOnChange = event => {
    const key = event.target.name;
    const value = event.target.value;
    onFieldChange(key, value);
  };

  const handleSubmitForm = event => {
    event.preventDefault();
    onSubmitForm();
  };

  const renderError = () => {
    let content = null;

    if (formStatus === 'error') {
      content = (
        <div className="contact-us__message contact-us__message--error">
          <p>
            {Translator.trans('contact_us.personal_info.error')} <br />
            {Translator.trans('contact_us.personal_info.error.firs_text')}.
          </p>
          <p>
            {Translator.trans('contact_us.personal_info.error.second_text')}
          </p>
        </div>
      );
    }

    return content;
  };

  const shouldComponentRender = () => {
    if (userType || formStatus === 'error') {
      if (userType === 'tenant' || userType === 'landlord') {
        if (userCountry) {
          return true;
        }
      } else {
        return true;
      }
    }

    return false;
  };

  return (
    shouldComponentRender() && (
      <div>
        <fieldset className="contact-us__wrapper">
          <legend>{Translator.trans('contact_us.personal_info.legend')}</legend>
          <p className="contact-us__item">
            <label htmlFor="requesterName">
              {Translator.trans('contact_us.personal_info.name')}
            </label>
            <input
              type="text"
              name="requesterName"
              id="requesterName"
              placeholder={Translator.trans('contact_us.personal_info.name')}
              required
              onChange={handleOnChange}
            />
          </p>

          <p className="contact-us__item">
            <label htmlFor="requesterEmail">
              {Translator.trans('contact_us.personal_info.email')}
            </label>
            <input
              type="email"
              name="requesterEmail"
              id="requesterEmail"
              placeholder={Translator.trans('contact_us.personal_info.email')}
              required
              onChange={handleOnChange}
            />
          </p>

          <p className="contact-us__item">
            <label htmlFor="subject">
              {Translator.trans('contact_us.personal_info.subject')}
            </label>
            <input
              type="text"
              name="subject"
              id="subject"
              placeholder={Translator.trans('contact_us.personal_info.subject')}
              required
              onChange={handleOnChange}
            />
          </p>

          <p className="contact-us__item">
            <label htmlFor="message">
              {Translator.trans('contact_us.personal_info.message')}
            </label>
            <textarea
              rows="4"
              cols="50"
              name="message"
              id="message"
              placeholder={Translator.trans('contact_us.personal_info.message')}
              required
              onChange={handleOnChange}
            />
          </p>

          {renderError()}

          <Button
            type="submit"
            size="big"
            fullWidth
            className="button button--wide"
            onClick={handleSubmitForm}
          >
            {Translator.trans('contact_us.personal_info.send')}
          </Button>
        </fieldset>

        {contactSaturation.isOn() ? (
          <SaturationMessage />
        ) : (
          <ContactData userType={userType} userCountry={userCountry} />
        )}
      </div>
    )
  );
};
PersonalInfo.propTypes = {
  userType: PropTypes.string,
  userCountry: PropTypes.string,
  requesterName: PropTypes.string,
  requesterEmail: PropTypes.string,
  subject: PropTypes.string,
  message: PropTypes.string,
  formStatus: PropTypes.string,
  onFieldChange: PropTypes.func,
  onSubmitForm: PropTypes.func
};
PersonalInfo.defaultProps = {
  userType: '',
  userCountry: '',
  requesterName: '',
  requesterEmail: '',
  subject: '',
  message: '',
  formStatus: '',
  onFieldChange: () => {},
  onSubmitForm: () => {}
};

export default PersonalInfo;
